import * as RegisterMethod from './omexcallbacks/RegisterMethods';
import * as StoreHelper from './util/InClientStoreHelper';
import { initializeExtensibilityContext } from 'owa-addins-boot';
import 'owa-addins-osfruntime';
/**
 * Initialize in client store

 */
const initializeStore = function initializeStore(): Promise<string> {
    const serviceEndPoint = StoreHelper.createServiceEndPoint();
    return initializeExtensibilityContext().then(() => {
        const storeUrl = StoreHelper.buildInClientStoreUrl();
        RegisterMethod.registerMethods(serviceEndPoint, storeUrl);
        return storeUrl;
    });
};
export default initializeStore;
